module.exports = __webpack_public_path__ + "funnel.f8acdfa7e28c3cb09f0d79723b71c788.svg";


//////////////////
// WEBPACK FOOTER
// ./web_modules/trustar/img/funnel.svg
// module id = 1654
// module chunks = 39